import ExpService from '../../../expr/ExpService';
import { Data } from '../../../expr/types';
import { Attribute } from '../index';
import { getAttributePath } from './getAttributePath';

export const getAttributeValue = (data: Data, attribute: Attribute): Data => {
  const expression = getAttributePath(attribute);
  const request = {
    expression,
    data,
    variables: {},
  };
  const result = ExpService.evaluate(request);
  return result.value;
};
